import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Recycle.es.js";
const c = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...o, weights: a }));
c.displayName = "RecycleIcon";
const n = c;
export {
  n as Recycle,
  c as RecycleIcon
};
